import Vue from "vue";
import VueRouter from "vue-router";
import login from "../components/login.vue";
import Home from "../views/Home.vue";
import students from "../views/students/students.vue";
import createStd from "../views/students/createStd.vue";
import updateStd from "../views/students/updateStd.vue";
import emps from "../views/emps/emps.vue";
import createEmp from "../views/emps/createEmp.vue";
import updateEmp from "../views/emps/updateEmp.vue";
import buses from "../views/buses/buses.vue";
import createBus from "../views/buses/createBus.vue";
import updateBus from "../views/buses/updateBus.vue";
import followBus from "../views/buses/followBus.vue";
import busMain from "../views/busMain/busMain.vue";
import createBusM from "../views/busMain/createBusM.vue";
import updateBusM from "../views/busMain/updateBusM.vue";
import income from "../views/Accounts/income.vue";
import outcome from "../views/Accounts/outcome.vue";
/*reports */
import studentR from "../views/report/studentR.vue";
import empR from "../views/report/empR.vue";
import busR from "../views/report/busR.vue";
import busMainR from "../views/report/busMainR.vue";
import bill from "../views/report/bill.vue";
import driverR from "../views/report/driverR.vue";
import driversAccountsR from "../views/report/driversAccountsR.vue";
import depitByBusR from "../views/report/depitByBusR.vue";
import creditByBusR from "../views/report/creditByBusR.vue";
import stdbillR from "../views/report/stdbillR.vue";
import studentContract from "../views/report/studentContract.vue";
import empContract from "../views/report/empContract.vue";
/*reports forms*/
import allsubscripe from "../views/reportForm/allsubscripe.vue";
import driversAccounts from "../views/reportForm/driversAccounts.vue";
import depitByBus from "../views/reportForm/depitByBus.vue";
import creditByBus from "../views/reportForm/creditByBus.vue";
import stdbill from "../views/reportForm/stdbill.vue";
/*controls */
import classesYears from "../views/controls/classesYears.vue";
import cities from "../views/controls/cities.vue";
import branches from "../views/controls/branches.vue";
import districts from "../views/controls/districts.vue";
import colleges from "../views/controls/colleges.vue";
import users from "../views/controls/user.vue";
/*roles */
import roles from "../views/roleAccess/roles.vue";
import createRole from "../views/roleAccess/createRole.vue";
import updateRole from "../views/roleAccess/updateRole.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Home",
    name: "Home",
    component: Home
  },
  {
    path: "/",
    name: "login",
    component: login
  },
  {
    path: "/students",
    name: "students",
    component: students
  },{
    path: "/createStd",
    name: "createStd",
    component: createStd
  },{
    path: "/updateStd/:id",
    name: "updateStd",
    component: updateStd
  },{
    path: "/emps",
    name: "emps",
    component: emps
   },{
    path: "/createEmp",
    name: "createEmp",
    component: createEmp
  },{
    path: "/updateEmp/:id",
    name: "updateEmp",
    component: updateEmp
  },{
    path: "/buses",
    name: "buses",
    component: buses
   },{
    path: "/createBus",
    name: "createBus",
    component: createBus
  },{
    path: "/updateBus/:id",
    name: "updateBus",
    component: updateBus
  },{
    path: "/busMain",
    name: "busMain",
    component: busMain
   },{
    path: "/createBusM",
    name: "createBusM",
    component: createBusM
  },{
    path: "/updateBusM/:id",
    name: "updateBusM",
    component: updateBusM
  },{
    path: "/income",
    name: "income",
    component: income
  },{
    path: "/outcome",
    name: "outcome",
    component: outcome
  }
  ,{
    path: "/cities",
    name: "cities",
    component: cities
  }  ,{
    path: "/branches",
    name: "branches",
    component: branches
  },{
    path: "/districts",
    name: "districts",
    component: districts
  }
  ,{
    path: "/colleges",
    name: "colleges",
    component: colleges
  }
  ,{
    path: "/followBus",
    name: "followBus",
    component: followBus
  },{
    path: "/studentR",
    name: "studentR",
    component: studentR,
    props : true
  }
  ,{
    path: "/empR",
    name: "empR",
    component: empR,
    props : true
  },{
    path: "/busR",
    name: "busR",
    component: busR,
    props : true
  },{
    path: "/busMainR",
    name: "busMainR",
    component: busMainR,
    props : true
  },{
    path: "/bill",
    name: "bill",
    component: bill,
    props : true
  },{
    path: "/driverR",
    name: "driverR",
    component: driverR,
    props : true
  },{
    path: "/classesYears",
    name: "classesYears",
    component: classesYears,
    props : true
  },{
    path: "/allsubscripe",
    name: "allsubscripe",
    component: allsubscripe,
    props : true
  }
  ,{
    path: "/driversAccounts",
    name: "driversAccounts",
    component: driversAccounts,
    props : true
  }
  ,{
    path: "/driversAccountsR",
    name: "driversAccountsR",
    component: driversAccountsR,
    props : true
  }  ,{
    path: "/depitByBus",
    name: "depitByBus",
    component: depitByBus,
    props : true
  }
  ,{
    path: "/depitByBusR",
    name: "depitByBusR",
    component: depitByBusR,
    props : true
  } ,{
    path: "/creditByBus",
    name: "creditByBus",
    component: creditByBus,
    props : true
  }
  ,{
    path: "/creditByBusR",
    name: "creditByBusR",
    component: creditByBusR,
    props : true
  },{
    path: "/stdbill",
    name: "stdbill",
    component: stdbill,
    props : true
  }
  ,{
    path: "/stdbillR",
    name: "stdbillR",
    component: stdbillR,
    props : true
  },{
    path: "/users",
    name: "users",
    component: users
  },{
    path: "/roles",
    name: "roles",
    component: roles
  },{
    path: "/createRole",
    name: "createRole",
    component: createRole
  },{
    path: "/updateRole/:id",
    name: "updateRole",
    component: updateRole
  },{
    path: "/studentContract",
    name: "studentContract",
    component: studentContract,
    props : true
  },{
    path: "/empContract",
    name: "empContract",
    component: empContract,
    props : true
  }
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
